import React from "react";
import PropTypes from "prop-types";
import { LegacyCard as Card, Layout, SkeletonBodyText, SkeletonDisplayText, BlockStack } from "@shopify/polaris";

const SkeletonAnnotatedCard = (props) => {
  const { annotatedLines = 3, primaryLines = 4 } = props;
  return (
    <>
      <Layout.AnnotatedSection
        title={<SkeletonDisplayText size="small" />}
        description={<SkeletonBodyText lines={annotatedLines} />}
      >
        <BlockStack gap="400">
          <Card sectioned>
            <SkeletonBodyText lines={primaryLines} />
          </Card>
          <Card sectioned>
            <SkeletonBodyText lines={primaryLines} />
          </Card>
          <Card sectioned>
            <SkeletonBodyText lines={primaryLines} />
          </Card>
          <Card sectioned>
            <SkeletonBodyText lines={primaryLines} />
          </Card>
          <Card sectioned>
            <SkeletonBodyText lines={primaryLines} />
          </Card>
        </BlockStack>
      </Layout.AnnotatedSection>
    </>
  );
};

SkeletonAnnotatedCard.propTypes = {
  annotatedLines: PropTypes.number,
  primaryLines: PropTypes.number,
};

SkeletonAnnotatedCard.defaultProps = {
  annotatedLines: 3,
  primaryLines: 2,
};

export default SkeletonAnnotatedCard;
